<template>
  <div style="position: relative;width: 100%;height: 100%;overflow: hidden">
    <div :id="uuid" style="width: 100%;height: 100%" />
    <div style="width: 100%;position: absolute;top: 50%;transform: translateY(-50%);background-size: 100% 100%"
      :style="{ height: width + 'px', zIndex: -1, backgroundImage: 'url(' + require('@/assets/custom/iconRing/' + bgIcons[progressIndex] + '.png') + ')' }">
    </div>
    <div style="width: 100%;text-align: center;position: absolute;top: 50%;transform: translateY(-50%);">
      <div style="font-family: '840CAI978',serif;"
        :style="{ fontSize: option.attribute.numSize + 'px', color: colors[progressIndex] }">
        {{ option.attribute.format.replace(/{value}/g, progress) }}
      </div>
      <div style="font-size: 14px;color: #ddd">{{ tags[progressIndex] }}</div>
    </div>
  </div>
</template>

<script>
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import * as echarts from 'echarts'
export default {
  name: "cpt-icon-ring",
  props: {
    width: Number,
    height: Number,
    option: Object,
    current: Object
  },
  computed: {
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  watch: {
    // 'option.attribute':{
    //   handler(obj) {
    //     this.processData(this.option.cptDataForm,this.newData,this.jsFunFlag);
    //     this.loadChart(obj);
    //   },
    //   deep: true//深度监听
    // },
    width() {
      this.chart.resize();
    },
    height() {
      this.chart.resize();
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  data() {
    return {
      uuid: '',
      chartOption: {},
      chart: null,
      cptData: {},
      progress: 0,
      bgIcons: ['info', 'waring', 'error'],
      colors: ['#00F3FF', '#FFBA55', '#F1325E'],
      tags: ['正常', '告警', '超负荷'],
      progressIndex: 0,
      newData: "",
      jsFunFlag: false,
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    const attr = this.option.attribute
    if (!attr.globalDataReload) attr.globalDataReload = [0]
  },
  mounted() {
    const element = document.getElementById(this.uuid)
    if (!element) {
      return
    }
    this.chart = echarts.init(element)
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm) {
      pollingRefresh(this.uuid, cptDataForm, () => this.loadData(cptDataForm))
    },
    loadData(cptDataForm) {
      const that = this;
      getDataJson(cptDataForm, '', (res) => {
        // this.cptData = res;
        that.newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag)
        this.loadChart(this.option.attribute);
      })
    },
    processData(cptDataForm, res, jsFunFlag) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == '4') {
        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) { // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            // 创建一个新的数组用于存储结果
            let newres = [];
            let newObj = { ...res[0] };
            // 如果dataKey中的value有值并且在newObj对象中有对应的值
            // if (dataKey[0].value && newObj[dataKey[0].value]) {
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            // }
            newres.push(newObj);
            // console.log(newres,'新数组');
            this.cptData = newres[0];
          }
        } else { // 如果配置了转换脚本
          this.cptData = res;
        }
      } else { // 不是数据集类型，是静态数据
        this.cptData = res;
      }
    },
    loadChart(attribute) {
      const that = this;
      that.progress = this.cptData.value > 100 ? 100 : this.cptData.value;
      that.progressIndex = 0;
      if (this.progress >= 90) {
        that.progressIndex = 2
      } else if (this.progress >= 70 && this.progress < 90) {
        that.progressIndex = 1
      }

      that.chartOption = {
        color: [that.colors[that.progressIndex], that.colors[that.progressIndex] + '66'],
        title: {
          text: attribute.title,
          left: 'center',
          top: 'bottom',
          textStyle: {
            fontSize: attribute.titleSize,
            color: attribute.titleColor
          },
        },
        series: [
          {
            name: attribute.title,
            type: 'pie',
            radius: [attribute.progressWidth + '%', '80%'],
            roseType: attribute.roseType === 'false' ? false : attribute.roseType,
            label: { show: false, },
            labelLine: { show: false },
            data: [
              { value: that.progress },
              { value: 100 - that.progress },
            ]
          }
        ]
      }
      that.chart.setOption(that.chartOption);
    },
  }
}
</script>

<style scoped></style>
